"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var Page_1 = __importDefault(require("./Page"));
var styles_1 = __importDefault(require("./styles"));
var Pagination = function (_a) {
    var className = _a.className, isHidden = _a.isHidden, style = _a.style, totalPages = _a.totalPages, currentPage = _a.currentPage, onClick = _a.onClick;
    if (isHidden)
        return null;
    return (react_1.default.createElement(styles_1.default, { className: "" + (className || ''), style: style },
        react_1.default.createElement(Icon_1.default, { className: "arrow " + (currentPage === 1 ? 'disabled' : ''), icon: "left", onClick: onClick.bind(undefined, currentPage - 1) }),
        react_1.default.createElement(Page_1.default, { isHidden: currentPage < 5, onClick: onClick }, 1),
        currentPage >= 5 && '...',
        react_1.default.createElement(Page_1.default, { isHidden: currentPage - 2 <= 0, onClick: onClick }, currentPage - 2),
        react_1.default.createElement(Page_1.default, { isHidden: currentPage - 1 <= 0, onClick: onClick }, currentPage - 1),
        react_1.default.createElement(Page_1.default, { onClick: onClick, isCurrent: true }, currentPage),
        react_1.default.createElement(Page_1.default, { isHidden: currentPage + 1 > totalPages, onClick: onClick }, currentPage + 1),
        react_1.default.createElement(Page_1.default, { isHidden: currentPage + 2 > totalPages, onClick: onClick }, currentPage + 2),
        totalPages - currentPage >= 5 && '...',
        react_1.default.createElement(Page_1.default, { isHidden: totalPages - currentPage < 5, onClick: onClick }, totalPages),
        react_1.default.createElement(Icon_1.default, { className: "arrow " + (currentPage === totalPages ? 'disabled' : ''), icon: "right", onClick: onClick.bind(undefined, currentPage + 1) })));
};
exports.default = Pagination;
//# sourceMappingURL=index.js.map